import { render, staticRenderFns } from "./volume-slider.vue?vue&type=template&id=0c09f7e0"
import script from "./volume-slider.vue?vue&type=script&lang=js"
export * from "./volume-slider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports